import { render, staticRenderFns } from "./ActionRecibirEquipo.vue?vue&type=template&id=7b7ac836&scoped=true&lang=pug"
import script from "./ActionRecibirEquipo.vue?vue&type=script&lang=js"
export * from "./ActionRecibirEquipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7ac836",
  null
  
)

export default component.exports